import GridSearchOutlined from '@/components/dataDisplay/GridSearchOutlined'
import GridToolbar from '@/components/dataDisplay/GridToolbar'

export const ResourceSteeringGridToolbar = () => {
  return (
    <GridToolbar
      filters={
        <GridSearchOutlined
          label="Search Resources"
          placeholder="Search by ID or name"
          sx={{
            maxWidth: 350,
          }}
        />
      }
    />
  )
}
